export default __webpack_public_path__ + "static/media/Group8398.d13eac43.svg";